var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmploymentLinked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.874 13.002H8.12402C5.43164 13.002 3.24902 15.1846 3.24902 17.877V40.627C3.24902 43.3193 5.43164 45.502 8.12402 45.502H43.874C46.5664 45.502 48.749 43.3193 48.749 40.627V17.877C48.749 15.1846 46.5664 13.002 43.874 13.002Z",
    stroke: "#D8D7E3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.626 13.001V9.75098C14.626 8.88902 14.9684 8.06237 15.5779 7.45288C16.1874 6.84339 17.014 6.50098 17.876 6.50098H34.126C34.9879 6.50098 35.8146 6.84339 36.4241 7.45288C37.0336 8.06237 37.376 8.88902 37.376 9.75098V13.001",
    stroke: "#D8D7E3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.749 24.376H3.24902",
    stroke: "#D8D7E3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5009 24.376V26.8138C32.5009 27.0293 32.4153 27.236 32.2629 27.3884C32.1105 27.5408 31.9038 27.6264 31.6883 27.6264H20.3116C20.0961 27.6264 19.8894 27.5408 19.737 27.3884C19.5846 27.236 19.499 27.0293 19.499 26.8138V24.376",
    stroke: "#D8D7E3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmploymentLinked);
export default __webpack_public_path__ + "static/media/employment-linked.bd3afb21.svg";
export { ForwardRef as ReactComponent };